import { render, staticRenderFns } from "./StandardInvestigationsList.vue?vue&type=template&id=3aa1856e&"
import script from "./StandardInvestigationsList.vue?vue&type=script&lang=ts&"
export * from "./StandardInvestigationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa1856e')) {
      api.createRecord('3aa1856e', component.options)
    } else {
      api.reload('3aa1856e', component.options)
    }
    module.hot.accept("./StandardInvestigationsList.vue?vue&type=template&id=3aa1856e&", function () {
      api.rerender('3aa1856e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/StandardInvestigationsList.vue"
export default component.exports